/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  deeplinkUrl: {
    path: null,
    pending: false,
  },
  oneTimeScreen: null,
  initialLocation: {
    path: null,
    pending: false,
  },
  hasSeenYoureIn: null,
  appStoreUrl: null,
  isSelfAssignedStudent: null,
};

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    updateDeeplinkUrl: (state, { payload }) => {
      state.deeplinkUrl = {
        path: payload,
        pending: true,
      };
    },
    setOneTimeScreen: (state, { payload }) => {
      state.oneTimeScreen = payload;
    },
    setInitialLocation: (state, { payload }) => {
      state.initialLocation = {
        path: payload,
        pending: true,
      };
    },
    clearInitialLocation: (state) => {
      state.initialLocation.pending = false;
    },
    clearPendingDeeplinkUrl: (state) => {
      state.deeplinkUrl.pending = false;
    },
    clearPendingDeeplinkStates: (state) => {
      state.deeplinkUrl.pending = false;
      state.initialLocation.pending = false;
    },
    // TODO(sc-19573): writerless after the signup-onboarding removal — the only
    // dispatch(setHasSeenYoureIn) was deleted, and its sole reader
    // (MatchingWizardRoute) was already a no-op. Remove this action + the
    // hasSeenYoureIn state in a follow-up cleanup.
    setHasSeenYoureIn: (state, { payload }) => {
      state.hasSeenYoureIn = payload;
    },
    setAppStoreUrl: (state, { payload }) => {
      state.appStoreUrl = payload;
    },
    handleResetBootstrapToPreUserState: (state) => {
      state.oneTimeScreen = null;
      state.initialLocation = {
        path: null,
        pending: false,
      };
      state.deeplinkUrl.pending = false;
      state.hasSeenYoureIn = null;
      state.isSelfAssignedStudent = null;
    },
    resetDeeplinkStates: (state) => {
      state.deeplinkUrl = {
        path: null,
        pending: false,
      };
      state.initialLocation = {
        path: null,
        pending: false,
      };
    },
    handleSelfAssignedStudentState: (state, { payload }) => {
      state.isSelfAssignedStudent = payload;
    },
  },
});

export const {
  updateDeeplinkUrl,
  setOneTimeScreen,
  setInitialLocation,
  clearInitialLocation,
  clearPendingDeeplinkUrl,
  clearPendingDeeplinkStates,
  setHasSeenYoureIn,
  setAppStoreUrl,
  handleResetBootstrapToPreUserState,
  handleSelfAssignedStudentState,
  resetDeeplinkStates,
} = sessionSlice.actions;

export const sessionSelector = (state) => state.session;

export default sessionSlice.reducer;
